import { jwtDecode } from "jwt-decode";
import CommentPost from "../commentsModal/CommentPost";
import useGetPostCommentsById from "../../hooks/useGetPostCommentsById";
import Spinner from "../spinner/Spinner";
import {
  PostCardProps,
  CommentPostCardListProps,
  TokenPayload,
} from "../../types/ComponentProps";
import PostCardHeader from "./PostCardHeader";
import PostCardMessage from "./PostCardMessage";
import PostCardFooter from "./PostCardFooter";
import CommentPostCard from "../commentsModal/CommentPostCard";
import PostCardStyles from "./PostCardStyles.module.css";
import { useImagePostModal } from "../../context/ImagePostModalContext";

const PostCard = ({
  post,
  socket,
  setSelectedCard,
  setSelectedCardModal,
  setEditPostModal,
  setEditCardSelection,
}: PostCardProps) => {
  const userDetails = jwtDecode<TokenPayload>(
    JSON.stringify(localStorage.getItem("accessTokenGC")),
  );

  const { openModal } = useImagePostModal();
  const {
    getPostComments,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
  } = useGetPostCommentsById(post?.postId ?? 0);

  const likesModal: React.MouseEventHandler<HTMLParagraphElement> = () => {
    if (setSelectedCard && setSelectedCardModal) {
      setSelectedCardModal(true);
      setSelectedCard(post);
    }
  };

  const onImageClickHandler = (index: number) => {
    openModal({ ...post, initialIndex: index });
  };

  return (
    <>
      <div className={PostCardStyles.postCardContainer}>
        <PostCardHeader
          userId={post?.userId}
          postId={post?.postId}
          dateCreated={post?.createdAt}
          preferredName={post?.user?.preferredName}
          pronouns={post?.user?.user_profile?.pronouns}
          pointsGiven={post?.pointsGiven}
          points={post?.user?.user_point}
          isAdmin={post?.user?.isAdmin}
          setEditPostModal={setEditPostModal}
          setEditCardSelection={setEditCardSelection}
        />
        <PostCardMessage
          message={post?.message}
          hashTagIds={post?.hashTagIds}
          recipients={post?.recipients}
        />
        {Array.isArray(post?.imageURL) && post.imageURL.length > 0 && (
          <div className={PostCardStyles.imageContainerGrid}>
            {post.imageURL.length === 1 && (
              <img
                alt="Uploaded"
                className={PostCardStyles?.uploadedImage}
                src={post.imageURL[0]}
                onClick={() => onImageClickHandler(0)}
                style={{ cursor: "pointer" }}
              />
            )}
            {post.imageURL.length === 2 && (
              <div className={PostCardStyles.gridTwoBlk}>
                {post.imageURL.map((url, i) => (
                  <div
                    key={i}
                    onClick={() => onImageClickHandler(i)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      alt="Uploaded"
                      className={PostCardStyles?.uploadedImage}
                      src={url}
                    />
                  </div>
                ))}
              </div>
            )}
            {post.imageURL.length === 3 && (
              <>
                <div className={PostCardStyles.gridThree}>
                  {post.imageURL.slice(0, 2).map((url, i) => (
                    <div
                      key={i}
                      onClick={() => onImageClickHandler(i)}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        alt="Uploaded"
                        className={PostCardStyles?.uploadedImage}
                        src={url}
                      />
                    </div>
                  ))}
                </div>
                <img
                  alt="Uploaded"
                  className={PostCardStyles?.uploadedImage}
                  src={post.imageURL[2]}
                  onClick={() => onImageClickHandler(2)}
                  style={{ cursor: "pointer" }}
                />
              </>
            )}
            {post.imageURL.length === 4 && (
              <div className={PostCardStyles.gridFour}>
                {post.imageURL.map((url, i) => (
                  <div
                    key={i}
                    onClick={() => onImageClickHandler(i)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      alt="Uploaded"
                      className={PostCardStyles?.uploadedImage}
                      src={url}
                    />
                  </div>
                ))}
              </div>
            )}
            {post.imageURL.length === 5 && (
              <>
                <div className={PostCardStyles.gridFiveBlk}>
                  {post.imageURL.slice(0, 2).map((url, i) => (
                    <div
                      key={i}
                      onClick={() => onImageClickHandler(i)}
                      style={{ cursor: "pointer" }}
                    >
                      <img alt="Uploaded" src={url} />
                    </div>
                  ))}
                </div>
                <div className={PostCardStyles.gridFiveBlk}>
                  {post.imageURL.slice(2, 5).map((url, i) => (
                    <div
                      key={i + 2}
                      onClick={() => onImageClickHandler(i + 2)}
                      style={{ cursor: "pointer" }}
                    >
                      <img alt="Uploaded" src={url} />
                    </div>
                  ))}
                </div>
              </>
            )}
            {post.imageURL.length > 5 && (
              <>
                <div className={PostCardStyles.gridFiveBlk}>
                  {post.imageURL.slice(0, 2).map((url, i) => (
                    <div
                      key={i}
                      onClick={() => onImageClickHandler(i)}
                      style={{ cursor: "pointer" }}
                    >
                      <img alt="Uploaded" src={url} />
                    </div>
                  ))}
                </div>
                <div className={PostCardStyles.gridFiveBlk}>
                  {post.imageURL.slice(2, 4).map((url, i) => (
                    <div
                      key={i + 2}
                      onClick={() => onImageClickHandler(i + 2)}
                      style={{ cursor: "pointer" }}
                    >
                      <img alt="Uploaded" src={url} />
                    </div>
                  ))}
                  <div
                    className={PostCardStyles.gridFiveBlkViewMore}
                    onClick={() => onImageClickHandler(4)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={PostCardStyles.gridFiveOverlayBlk}>
                      <h1>{`+${post?.imageURL.length - 5}`}</h1>
                    </div>
                    <img alt="Uploaded" src={post.imageURL[4]} />
                  </div>
                </div>
              </>
            )}
          </div>
        )}
        {post?.likes?.length === 0 || post?.likes === null ? null : post.likes
            .length === 1 && userDetails?.id === post.likes[0]?.id ? (
          <div className={PostCardStyles.likeContainer} onClick={likesModal}>
            <p>You reacted to this post</p>
          </div>
        ) : (
          <div className={PostCardStyles.likeContainer} onClick={likesModal}>
            <i className="fa-solid fa-thumbs-up"></i>
            <p>{post?.likes?.length} people reacted to this post</p>
          </div>
        )}
        <PostCardFooter post={post} socket={socket} />
        <hr className={PostCardStyles.hrStyles} />
        {isLoading ? (
          <Spinner variant="medium-spinner" alignSpin="center-spinner" />
        ) : getPostComments?.pages?.flatMap((page) => page.comments).length ===
          0 ? (
          <p className={PostCardStyles.beTheFirstSectionBlk}>
            Be the first to comment on this post.
          </p>
        ) : (
          getPostComments?.pages?.flatMap((page) =>
            page.comments.map((data: CommentPostCardListProps["comments"]) => (
              <CommentPostCard key={data.commentId} data={data} />
            )),
          )
        )}
        {isFetchingNextPage ? (
          <Spinner variant="small-spinner" alignSpin="center-spinner" />
        ) : null}
        {getPostComments?.pages[0]?.pagination?.totalItems > 3 &&
          hasNextPage && (
            <div className={PostCardStyles.showAllCommentsSection}>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  fetchNextPage();
                }}
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? null : "View previous comments"}
              </button>
            </div>
          )}
        <CommentPost post={post} socket={socket} />
      </div>
    </>
  );
};

export default PostCard;
